import React, {useState} from 'react';
import classNames from 'classnames'
import { getInvoicePdf } from '@portal/kit/pkg/services'
import { Notification } from '@portal/kit/pkg/components'
import { useTheme } from "react-jss"
import { dateToLocaleString } from 'helpers/date'
import { useTranslation } from "react-i18next"
import invoiceTableStyle from '../invoices-table-style'

export default function InvoiceView ({invoice: {id, created_at, total_price_taxes_included } }) {
  const [errorMsg, setErrorMsg] = useState()
  const { t, i18n } = useTranslation()
  const theme = useTheme()
  const classes = invoiceTableStyle(theme)

  const fetchInvoicePdfLink = async () => {
    try {
      const response = await getInvoicePdf(id)
      const blob = new Blob([response.data], { type: 'application/pdf' } )
      const url = window.URL.createObjectURL(blob)

      window.open(url);
    } catch (error) {
      setErrorMsg(error)
    }
  }

  return (
    <>
      {errorMsg && <Notification status='fail' message={t('errors.invoices.can_not_download')} />}
      <div key={id} className={classes.tableInvoicesRow}>
        <div className={classes.tableInvoicesNum}>{id || '-'}</div>
        <div className={classes.tableInvoicesDate}>
           {dateToLocaleString({ date: created_at, language: i18n.language }) || '-'}
        </div>
        <div className={classes.tableInvoicesTotal}>{total_price_taxes_included || '-'} €</div>
        <div className={classes.tableInvoicesAction}>
          <button onClick={fetchInvoicePdfLink} className={classNames('fal', 'fa-file-download', classes.tableInvoiceDownload)} />
        </div>
      </div>
    </>
  )
}
